import React, { useState } from 'react';

//Component
import { Button, Select, MenuItem, TextField, OutlinedInput } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';

//Hook & lib
import {
  useLazyGetUsersByCampQuery,
  useLazyGetEventsByCampQuery,
  useGetAllCampsQuery,
  useCreateRubricMutation,
} from '../../redux';
import { useEnqueueStacks } from '../../hooks/use-enqueue-stacks';

//Css
import styled from 'styled-components';

const Root = styled.div`
  margin-top: 2%;
`;

const Label = styled.label`
  display: flex;
  flex: wrap;
  margin-bottom: 1%;
  font-size: 16px;
  font-weight: 600;
`;

const Row = styled.div`
  margin-top: 1%;
  margin-right: 4%;
`;

const SubmitRow = styled.div`
  margin-top: 1%;
  margin-right: 4%;
  display: flex;
  justify-content: flex-end;
`;

const FlatRows = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const Form = styled.form``;

const initialFormValues = {
  camp: '-',
  event: '-',
  name: '',
  maxPoints: 0,
  assignedJudge: [],
  isLoading: false,
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export const CreateRubric = props => {
  const { handleClose } = props;
  const [formData, setFormData] = useState(initialFormValues);

  const { enqueueSuccess, enqueueError } = useEnqueueStacks();
  //API Calls
  const camp = useGetAllCampsQuery({});
  const [getUsersByCamp, { data: judges }] = useLazyGetUsersByCampQuery();
  const [getEventsByCamp, { data: events }] = useLazyGetEventsByCampQuery();
  const [createRubric] = useCreateRubricMutation();

  const handleChange = async e => {
    setFormData(curr => {
      return { ...curr, [e.target.name]: e.target.value };
    });

    if (e.target.name === 'camp') {
      await getEventsByCamp(e.target.value);
      await getUsersByCamp({ _id: e.target.value });
    }
  };

  const handleLoading = isLoading => {
    setFormData(curr => {
      return { ...curr, isLoading };
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      handleLoading(true);
      if (formData.maxPoints > 0) {
        const res = await createRubric({ ...formData });
        if (!res.error) {
          enqueueSuccess(`El rubro ${formData.name} fue creado exitosamente`, {
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
        }
        handleClose();
      } else {
        enqueueError('la puntuacion maxima debe ser mayor a 0', {
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
    } catch (err) {
      console.err(err);
      enqueueError('you encounter an error please review the console', {
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    } finally {
      handleLoading(false);
    }
  };

  return (
    <Root>
      <Form>
        <FlatRows>
          <Row>
            <Label>Nombre</Label>
            <TextField
              required
              name='name'
              label='Required'
              value={formData.name}
              onChange={handleChange}
              autoComplete='off'
              fullWidth
            />
          </Row>
          <Row>
            <Label>Puntacion maxima</Label>
            <TextField
              required
              name='maxPoints'
              label='Required'
              type='number'
              value={formData.maxPoints}
              onChange={handleChange}
              autoComplete='off'
              fullWidth
            />
          </Row>
        </FlatRows>
        <FlatRows>
          <Row>
            <Label>Campamento</Label>
            <Select
              required
              name='camp'
              label='Required'
              value={formData.camp}
              onChange={handleChange}
              defaultValue='-'
              fullWidth
              size='medium'
              sx={{ width: '250px' }}
            >
              <MenuItem value={'-'} disabled>
                Selecione un Campamento
              </MenuItem>
              {camp.data &&
                camp.data.map(option => {
                  return (
                    <MenuItem key={option._id} value={option._id}>
                      {option.name}
                    </MenuItem>
                  );
                })}
            </Select>
          </Row>
          <Row>
            <Label>Evento</Label>
            <Select
              required
              name='event'
              label='Required'
              value={formData.event}
              onChange={handleChange}
              defaultValue='-'
              fullWidth
              size='medium'
              sx={{ width: '225px' }}
            >
              <MenuItem value={'-'} disabled>
                Selecione un evento
              </MenuItem>

              {events &&
                events.map(option => {
                  return (
                    <MenuItem key={option._id} value={option._id}>
                      {option.name}
                    </MenuItem>
                  );
                })}
            </Select>
          </Row>
          <Row>
            <Label>Jueces</Label>
            <Select
              required
              id='assignedJudge'
              name='assignedJudge'
              value={formData.assignedJudge}
              onChange={handleChange}
              fullWidth
              size='medium'
              sx={{ width: '225px' }}
              multiple
              input={<OutlinedInput label='Jueces' />}
              renderValue={selected => {
                const selectedJudges = selected.map(value => {
                  const judge = judges.find(judge => judge._id === value);
                  return judge ? judge.fullname : value;
                });
                return selectedJudges.join(', ');
              }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                    width: 250,
                  },
                },
              }}
            >
              {judges &&
                judges?.map(option => {
                  return (
                    <MenuItem key={option._id} value={option._id}>
                      <Checkbox checked={formData.assignedJudge.indexOf(option._id) > -1} />
                      {option.fullname}
                    </MenuItem>
                  );
                })}
            </Select>
          </Row>
        </FlatRows>
        <SubmitRow>
          <Button disabled={formData.isLoading} onClick={handleSubmit} variant='contained' type='submit'>
            Guardar
          </Button>
        </SubmitRow>
      </Form>
    </Root>
  );
};
